import core from '@gin-betting/core';

import { Modules } from 'types';
import moduleLocator from 'moduleLocator';

const {
    hocs: { withAsyncLoad },
    utils: { measureTime },
} = core;

export async function loadFreebetModule(): Promise<Modules['freebet']> {
    return import(/* webpackChunkName: "freebet-module" */ '../index').then(
        module => {
            measureTime('freebetModuleLoaded');
            moduleLocator.set('freebet', module);

            return module;
        }
    );
}

export const AsyncBetslipFreebet = withAsyncLoad({
    loader: loadFreebetModule,
    loading: () => null,
    componentToRender: 'BetslipFreebet',
});

export const AsyncFreebetPanel = withAsyncLoad({
    loader: loadFreebetModule,
    loading: () => null,
    componentToRender: 'FreebetPanel',
});

export const AsyncFreebetSelect = withAsyncLoad({
    loader: loadFreebetModule,
    loading: () => null,
    componentToRender: 'FreebetSelect',
});
